import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { translate } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEqual, get } from 'lodash';
import { Popconfirm } from 'antd';

import EventAdminCampaignTicketForm from './EventAdminCampaignTicketFormContainer';
import FundkyDragDrop from 'Parts/ui/components/FundkyDragDrop';
import FundkyButton from 'Parts/ui/components/FundkyButton';
import { moneyFormat } from 'Parts/common/moneyFormat';

import './EventAdminCampaignTicketList.less';

import eventAdminCampaignTicketListEN from './locales/EventAdminCampaignTicketList_en.json';
import eventAdminCampaignTicketListFR from './locales/EventAdminCampaignTicketList_fr.json';

class EventAdminCampaignTicketList extends Component {
  constructor(props) {
    super(props);

    props.fetchTicketList(props.campaignId, { showDescription: true }, true);
    props.fetchEvent(props.campaignId, true, { showLocation: true, showSettings: true });

    this.state = {
      tickets: props.tickets.results || [],
      isAddingTicket: false,
      isEditingTicket: false,
      langUpdateIndex: 0,
      weight: []
    };

    this.actions = [
      { onClick: this.handleEdit, title: 'edit', icon: 'edit' },
      // { onClick: this.handleChart, title: 'chart', icon: 'chart-pie' },
      // { onClick: this.handleCopy, title: 'copy', icon: 'copy' },
      { onClick: this.handleDelete, title: 'delete', icon: 'trash-alt' }
    ];

    i18next.addResourceBundle('en', 'EventAdminCampaignTicketList', eventAdminCampaignTicketListEN);
    i18next.addResourceBundle('fr', 'EventAdminCampaignTicketList', eventAdminCampaignTicketListFR);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.tickets, this.props.tickets)) {
      this.setState({
        tickets: this.props.tickets.results || [],
        isEditingTicket: false,
        isAddingTicket: false,
        langUpdateIndex: this.state.langUpdateIndex + 1
      });
    }
  }

  handleWeight = items => {
    let _index = [];
    let _updated = false;

    Promise.all([
      ...items
        // Save index into _index
        .map((item, index) => {
          _index[item.props.id] = index;
          return item;
        })
        // Select changed order only
        .filter((item, index) => item.props.id !== this.state.tickets[index].id)
        // Update order
        .map(item => {
          _updated = true;
          return this.props.updateTicket(
            this.props.campaignId,
            item.props.id,
            { weight: (items.length - _index[item.props.id]) * 100 },
            null,
            null,
            null,
            false, // notif
            false // fetch
          );
        })
    ]).then(
      () =>
        _updated &&
        this.props.fetchTicketList(this.props.campaignId, { showDescription: true }, true)
    );
  };

  handleEdit = ({ id }) => {
    this.setState(prevState => {
      let tickets = prevState.tickets.map(ticket => {
        if (ticket.id === id) {
          ticket.isEditing = true;
          return ticket;
        }
        return ticket;
      });

      return {
        isEditingTicket: true,
        tickets
      };
    });
  };

  handleChart = ({ id }) => {};

  handleCopy = ticket => {};

  handleDelete = ({ id }) => {
    this.props.deleteTicket(this.props.campaignId, id);
  };

  handleAddTicket = () => {
    const { t } = this.props;

    this.setState(prevState => {
      let tickets = prevState.tickets.concat({
        id: 'temp',
        description: { name: t('new-ticket') },
        sold: 0,
        available: 0,
        price: 0,
        isAdding: true
      });

      return {
        tickets,
        isAddingTicket: true
      };
    });
  };

  handleCancelAddTicket = id => {
    if (this.state.isAddingTicket) {
      this.setState(prevState => {
        let tickets = prevState.tickets;
        tickets.pop();
        return {
          tickets,
          isAddingTicket: false
        };
      });
    } else {
      this.props.clearTicket();

      this.setState(prevState => {
        let tickets = prevState.tickets.map(ticket => {
          if (ticket.id === id) {
            ticket.isEditing = false;
            return ticket;
          }
          return ticket;
        });

        return {
          isEditingTicket: false,
          tickets
        };
      });
    }
  };

  render() {
    const { t, locale } = this.props;
    const { tickets, langUpdateIndex } = this.state;

    return (
      <div id="Tickets">
        <div id="Tickets__list">
          {tickets.length ? (
            <FundkyDragDrop
              key={`${locale} ${langUpdateIndex} ${tickets.length} ${this.state.isAddingTicket} ${this.state.isEditingTicket}`}
              isDragDisabled={this.state.isAddingTicket || this.state.isEditingTicket}
              locale={locale}
              onChange={this.handleWeight}
            >
              {tickets.map(ticket => {
                const isEditingOrAdding = tickets.some(
                  ticket => ticket.isEditing || ticket.isAdding
                );

                let ticketName = get(ticket, 'description.name', null);
                let ticketSold = `${t('sold', {
                  count: ticket.quantity - ticket.available || 0
                })} / ${t('available', { count: ticket.available || 0 })}`;
                let ticketPrice = moneyFormat(ticket.totalPrice, i18next.language, false, 'CAD');

                return (
                  <div key={locale + ticket.id + "_" + langUpdateIndex} id={ticket.id} className="Ticket">
                    <div className="Ticket__body">
                      <div className="Ticket__handle">
                        <FontAwesomeIcon icon={['far', 'ellipsis-v']} size="1x" />
                      </div>
                      <div className="Ticket__content">
                        <div className="Ticket__content-name" title={ticketName}>
                          <b>{ticketName}</b>
                        </div>
                        {(!ticket.isEditing || !ticket.isAdding) && (
                          <>
                            <div className="Ticket__content-sold" title={ticketSold}>
                              {ticketSold}
                            </div>
                            <div className="Ticket__content-price" title={ticketPrice}>
                              {ticketPrice}
                            </div>
                          </>
                        )}
                      </div>

                      {(!ticket.isEditing || !ticket.isAdding) && (
                        <div className="Ticket__actions">
                          {this.actions.map(action =>
                            action.title === 'delete' ? (
                              <Popconfirm
                                key={action.icon}
                                onConfirm={() => action.onClick(ticket)}
                                title={t('delete-question')}
                                okText={t('yes')}
                                cancelText={t('no')}
                                placement="left"
                              >
                                <a
                                  key={action.icon}
                                  title={t(action.title)}
                                  disabled={
                                    isEditingOrAdding ||
                                    //* Already 1 ticket sold /
                                    ticket.quantity - ticket.available > 0
                                      ? true
                                      : false //||
                                    //* in progress /
                                    //THE TAG DOESN'T UPDATE THE isDeleteTicketInProgress VALUE WHEN IT CAME BACK TO FALSE ... COMMENTED UNTIL SOLUTION
                                    //this.props.isDeleteTicketInProgress
                                  }
                                >
                                  <FontAwesomeIcon icon={['fal', action.icon]} />
                                </a>
                              </Popconfirm>
                            ) : (
                              <a
                                key={action.icon}
                                onClick={() => action.onClick(ticket)}
                                title={t(action.title)}
                                disabled={isEditingOrAdding}
                              >
                                <FontAwesomeIcon icon={['fal', action.icon]} />
                              </a>
                            )
                          )}
                        </div>
                      )}
                    </div>
                    {(ticket.isEditing || ticket.isAdding) && (
                      <div className="Ticket__form">
                        <EventAdminCampaignTicketForm
                          //handleCropComplete={this.handleCropComplete}
                          ticketId={ticket.id}
                          handleCancelAddTicket={() => this.handleCancelAddTicket(ticket.id)}
                          isEditing={ticket.isEditing}
                          isAdding={ticket.isAdding}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </FundkyDragDrop>
          ) : (
            <p>{t('no-tickets-listed')}</p>
          )}
        </div>
        <FundkyButton
          action={{ func: this.handleAddTicket, param: null }}
          type="secondary"
          text={t('add-ticket')}
          className="add-ticket"
          icon={['far', 'plus']}
          disabled={
            this.state.isAddingTicket || this.state.isEditingTicket
          }
          htmlType="button"
        />
      </div>
    );
  }
}

EventAdminCampaignTicketList.propTypes = {};

export default translate('EventAdminCampaignTicketList')(EventAdminCampaignTicketList);
